import { COLORS } from 'consts/colors'
import styled, { css } from 'styled-components'
import { normalizeAndConvertAspectRatioForCSS } from 'utils/aspectRatio'

interface IAiSkeletonItemWrapperProps {
  width?: string
  height?: string
  $aspectRatio?: string
}

export const AiSkeletonItemWrapper = styled.div<IAiSkeletonItemWrapperProps>`
  position: relative;
  width: ${({ width }) => (width ? width : '100%')};
  height: ${({ height }) => (height ? height : '100%')};
  border-radius: 4px;
  pointer-events: none;
  background-color: ${COLORS.primaryLight};

  ${({ $aspectRatio }) =>
    $aspectRatio &&
    css`
      aspect-ratio: ${normalizeAndConvertAspectRatioForCSS($aspectRatio)};
    `}
`
